import React, { useState, useEffect } from 'react';

import Quicks from '../../components/quicks';
import PersonBox from '../../components/person-box';

import './index.css';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/people/people.json`;

    const [people, setPeople] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setPeople(reply);
            });
    }, []);
    return (
        <div className="container">
            <Quicks
                external
                links={[]}
                navs={[
                    { name: 'Current Members', link: '#CurrentMembers' },
                    { name: 'Former Members', link: '#FormerMembers' }
                ]}
            />

            <div className="people-container row justify-content-center">
                <h3 id="CurrentMembers">Current Members</h3>
                {people
                    .filter((person) => person.currentMember)
                    .map((person) => (
                        <PersonBox
                            name={person.name}
                            username={person.username}
                            labRole={person.role}
                            showBiography={person.showBiography}
                        />
                    ))}
            </div>
            <div className="people-container row justify-content-center">
                <h3 id="FormerMembers">Former Members</h3>
                {people
                    .filter((person) => !person.currentMember)
                    .map((person) => (
                        <PersonBox
                            name={person.name}
                            username={person.username}
                            labRole={person.role}
                            showBiography={person.showBiography}
                        />
                    ))}
            </div>
        </div>
    );
};

export default Component;
